import { classeParaLabelsFormularioComFundoEscuroSimplificada } from "app/estilos/classeParaLabelsFormularioComFundoEscuro";
import clsx from "clsx";
import React from "react";
import globalMU from "../../../globalMU";

const estiloTabela = require('../../estilos/tabelas.module.scss').default
const estilosFormulario = require('../../estilos/formulario.module.scss').default


export type FiltroFichaFinanceira = {
  CodigoCliente: number,
  DataReferencia?: Date,
  TipoPessoa?: string,
  TipoConsulta?: string,
  NumeroPagina?: number,
  TamanhoPagina?: number
}

export type DadosFichaFinanceira = {
  CompraAtualXMedio: number;
  Credito: string;
  DataEmissaoUltimaNotaFiscal: string;
  DataLimiteCredito: string;
  DataMaiorAtrasoPago: string;
  DataMaiorCompra: string;
  DataMaiorCredito: string;
  DataPrimeiraCompra: string;
  DataUltimaCompra: string;
  MediaAtraso: number;
  NumeroDiasUltimaCompra: number;
  Observacao: string;
  Pontualidade: number;
  QuantidadeAtrasos: number;
  QuantidadeComprasAPrazo: number;
  QuantidadeComprasAVista: number;
  QuantidadeDiasAtrasoPago: number;
  QuantidadeDiasMaiorAtraso: number;
  QuantidadePagamentosAtrasados: number;
  QuantidadeTotalCompra: number;
  Saldo: number;
  ValorAVencer: number;
  ValorCompraAVista: number;
  ValorCompraPrazo: number;
  ValorCredito: number;
  ValorLimiteCredito: number;
  ValorMaiorAtrasoEmAberto: number;
  ValorMaiorAtrasoPago: number;
  ValorMaiorCompra: number;
  ValorMaiorCredito: number;
  ValorMedioCompra: number;
  ValorPedidoAguardandoFaturamento: number;
  ValorPrimeiraCompra: number;
  ValorTotalCompras: number;
  ValorUltimaCompra: number;
  ValorVencido: number;
  ValorTotalPago: number;
  UserMessage: string;
};

export type FichaFinanceiraProps = {
  dadosFichaFinanceira: DadosFichaFinanceira;
  cpfCnpj: string,
  nome: string,
};

export const FichaFinanceiraCliente = (props: FichaFinanceiraProps) => {

  const dadosFichaFinanceiraCliente =
    <section className={clsx(estilosFormulario.formularioSimplificado, classeParaLabelsFormularioComFundoEscuroSimplificada)}>
      <label>CPF/CNPJ</label><span>{props.cpfCnpj}</span>
      <label>Nome</label><span>{props.nome}</span>
      {<section style={{ marginBottom: "20px" }} />}
    </section>

  const linhaMaiorCompra =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Maior Compra</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataMaiorCompra}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorMaiorCompra, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Maior Atraso</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.QuantidadeDiasMaiorAtraso, 0, false)}</td>
    </tr>

  const linhaMaiorCredito =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Maior Crédito</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataMaiorCredito}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorMaiorCredito, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Data Atraso</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataMaiorAtrasoPago}</td>
    </tr>

  const linhaLimiteCredito =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Limite Crédito</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataLimiteCredito}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorLimiteCredito, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Pagtos Atras.</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.QuantidadePagamentosAtrasados}</td>
    </tr>

  const linhaPrimeiraCompra =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Primeira Compra</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataPrimeiraCompra}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorPrimeiraCompra, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Média Atraso</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.MediaAtraso, 1, false)}</td>
    </tr>

  const linhaUltimaCompra =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Última Compra</th>
      <td style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.DataUltimaCompra}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorUltimaCompra, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Pontualidade</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.Pontualidade, 1, false)}%</td>
    </tr>

  const linhaNumeroDiasUltimaCompra =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Nº Dias Última Compra</th>
      <td colSpan={2} style={{ paddingTop: "unset" }}>{props.dadosFichaFinanceira?.NumeroDiasUltimaCompra}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total Pago</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorTotalPago, 2, false)}</td>
    </tr>

  const linhaComprasAVista =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Compras à Vista</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.QuantidadeComprasAVista, 0, false)}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorCompraAVista, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>A Vencer</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorAVencer, 2, false)}</td>
    </tr>

  const linhaComprasAPrazo =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Compras a Prazo</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.QuantidadeComprasAPrazo, 0, false)}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorCompraPrazo, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Vencido</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorVencido, 2, false)}</td>
    </tr>

  const linhaTotais =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>TOTAIS</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.QuantidadeTotalCompra, 0, false)}</td>
      <td style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorTotalCompras, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Saldo</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.Saldo, 2, false)}</td>
    </tr>

  const linhaMediaCompra =
    <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Valor Médio de Compra</th>
      <td colSpan={2} style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.ValorMedioCompra, 2, false)}</td>
      <th style={{ paddingTop: "unset" }} className={estiloTabela.cabecalhoNumerico}>Total Acumulado</th>
      <td style={{ paddingTop: "unset" }}>{globalMU.formatarValorNumerico(props.dadosFichaFinanceira?.Saldo + props.dadosFichaFinanceira?.ValorTotalPago, 2, false)}</td>
    </tr>

  const tabelaFichaFinanceira =
    <table className={`_table _w-full _border-collapse text-right ${estiloTabela.tabela}`}>
      <thead>
        <tr>
          <th></th>
          <th className={estiloTabela.cabecalhoTexto}>Data</th>
          <th className={estiloTabela.cabecalhoNumerico}>Valor Nominal</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {linhaMaiorCompra}
        {linhaMaiorCredito}
        {linhaLimiteCredito}
        {linhaPrimeiraCompra}
        {linhaUltimaCompra}
        {linhaNumeroDiasUltimaCompra}
      </tbody>

      <thead>
        <tr>
          <th></th>
          <th className={estiloTabela.cabecalhoTexto}>Número</th>
          <th className={estiloTabela.cabecalhoNumerico}>Valor Nominal</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {linhaComprasAVista}
        {linhaComprasAPrazo}
        {linhaTotais}
        {linhaMediaCompra}
      </tbody>
      <tfoot style={{ height: "25px" }}><tr><td colSpan={5}></td></tr></tfoot>
    </table>

  return (
    <div>
      {dadosFichaFinanceiraCliente}
      {tabelaFichaFinanceira}
      {<section style={{ marginBottom: "100px" }} />}
    </div>
  );
};
